"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchoolType = void 0;
var SchoolType;
(function (SchoolType) {
    SchoolType[SchoolType["Public"] = 0] = "Public";
    SchoolType[SchoolType["Charter"] = 1] = "Charter";
    SchoolType[SchoolType["State"] = 2] = "State";
    SchoolType[SchoolType["Private"] = 3] = "Private";
})(SchoolType = exports.SchoolType || (exports.SchoolType = {}));
//# sourceMappingURL=SchoolType.js.map